import { connect } from 'react-redux';
import {
  GET_TRANSFORMED_SAMPLES_FROM_FLAT_TO_NEST_REQUEST,
  GET_DATA_SAMPLES_REQUEST,
} from 'js/constants/actionTypes';
import { DestinationPayload } from './DestinationPayload';
import { updateFormData, fetchTransformedPayloadFromEditorForRest } from 'js/actions';

const mapStateToProps = (state, ownProps) => {
  const { request, forms } = state;
  const formData = forms[forms.activeType] ? forms[forms.activeType].data : {};
  const { dataSetId, toNested, previewPayload, previewPayloadError } = formData;
  const sinkConfig = formData?.sinkConfig;
  const dataFormat = sinkConfig && sinkConfig.data_format;
  const contentType =
    dataFormat === 'xml' || dataFormat === 'edi'
      ? 'application/xml'
      : (sinkConfig && sinkConfig['content.type']) || 'application/json';
  const isLoadingProbeSample = !!(
    request[GET_TRANSFORMED_SAMPLES_FROM_FLAT_TO_NEST_REQUEST] || request[GET_DATA_SAMPLES_REQUEST]
  );

  const credID = formData?.selectedCredentialId ?? formData?.credentialId;

  return {
    sinkConfig,
    previewPayload,
    dataSetId,
    samples: toNested,
    contentType,
    error: previewPayloadError,
    isLoadingProbeSample,
    selectedCredentialId: credID,
    onToggleDestinationDraft: ownProps.onToggleDestinationDraft,
    // Pass through parent dataset information for macro replacement (api server flows)
    parentDataSet: ownProps.parentDataSet,
    parentDataSetSamples: ownProps.parentDataSetSamples,
  };
};

export default connect(mapStateToProps, {
  updateFormData,
  fetchTransformedPayloadFromEditorForRest,
})(DestinationPayload);
